<template>
  <!-- O chassi é o AskDialog, que é o mesmo de toda pergunta da casa. Aqui fica só o que é
       DESTE aviso: qual mensagem e qual ícone, conforme a saída pendente. -->
  <ontos-ask-dialog v-if="leaving" :title="$tt('unsaved-changes')" :message="message"
                    :actions="actions"
                    @pick="$emit($event === 'leave' ? 'confirmed' : 'cancelled')"
                    @closed="$emit('cancelled')"/>
</template>
<script lang="ts">
import {Component, Vue, Prop, toNative} from 'vue-facing-decorator'
import AskDialog, {Ask} from '@/components/shared/AskDialog.vue'

/**
 * Por onde se está tentando sair de um formulário.
 *
 * `back` não encerra a tela: devolve o que ela mostrava antes — a ficha de onde se foi editar,
 * seja ela um passo do modal ou a rota. Para quem sai, porém, é a mesma perda que fechar, e por
 * isso divide o mesmo aviso.
 */
export type Leave = 'full-page' | 'close' | 'back'

/**
 * "Há alterações não salvas": o aviso antes de abandonar um formulário.
 *
 * Mora fora de quem o mostra porque não é só do modal: a rota de editar tem o mesmo Voltar e a
 * mesma perda. Estava dentro do `DialogActions`, e a rota teria de copiar o card, as duas ações e
 * a escolha da mensagem para dizer a mesma coisa.
 *
 * **Fica onde foi desenhado**: dentro da árvore de quem o mostra. É assim que o Vuetify descobre
 * os diálogos aninhados — fora dela, o modal de baixo disputaria o foco com este aviso.
 *
 * Daqui não sai navegação nenhuma: só `confirmed` e `cancelled`. Quem sabe o que cada saída faz
 * é quem a ofereceu.
 */
@Component({
  emits: ['confirmed', 'cancelled'],
  name: 'ontos-unsaved-changes-dialog',
  components: {'ontos-ask-dialog': AskDialog}
})
class UnsavedChangesDialog extends Vue {
  /** A saída pendente, que escolhe a mensagem e o ícone. Null fecha o aviso. */
  @Prop({type: String, default: null}) readonly leaving!: Leave | null

  //Mesmo aviso para as três: só o que se perde é que muda de uma para a outra
  get message(): string {
    const key = this.leaving === 'close' ? 'unsaved-close-confirm'
        : this.leaving === 'back' ? 'unsaved-back-confirm'
            : 'unsaved-leave-confirm'
    return this.$tt(key) as string
  }

  get actions(): Ask[] {
    return [
      {value: 'leave', label: this.$tt('leave-without-saving') as string, icon: this.icon, color: 'primary'},
      {value: 'stay', label: this.$tt('cancel') as string, icon: 'mdi-cancel'}
    ]
  }

  get icon(): string {
    return this.leaving === 'close' ? 'mdi-close'
        : this.leaving === 'back' ? 'mdi-arrow-left'
            : 'mdi-open-in-new'
  }
}

export default toNative(UnsavedChangesDialog)
</script>
